import './HistoricalPercentageChangeWidgetChart.scss';
import { useHistoricalPercentageChangeData } from 'widgets/historicalPercentageChange/data/useHistoricalPercentageChangeData';
import React, { useRef } from 'react';
import { useHistoricalPercentageChangeWidgetChartDimensions } from 'widgets/historicalPercentageChange/widget/components/chart/dimensions';
import { useWidgetContext } from 'widgets/WidgetContext.tsx';
import { useHistoricalPercentageChangeWidgetConfigSlice } from 'widgets/historicalPercentageChange/widget/store.ts';
import { HistoricalPercentageChangeWidgetChartLegends } from 'widgets/historicalPercentageChange/widget/components/chart/HistoricalPercentageChangeWidgetChartLegends.tsx';
import { HistoricalPercentageChangeChart } from 'widgets/historicalPercentageChange/components/HistoricalPercentageChangeChart/HistoricalPercentageChangeChart.tsx';
import { BarMouseOver } from 'widgets/historicalPercentageChange/components/HistoricalPercentageChangeChart/barMouseOver.ts';
import { HistPriceVolDataState } from 'widgets/historicalPercentageChange/store/data/HistoricalPercentageChangeDataState.ts';
import classNames from 'classnames';

export function HistoricalPercentageChangeWidgetChart({
    streamData,
}: {
    streamData: HistPriceVolDataState;
}) {
    const data = useHistoricalPercentageChangeData(streamData);
    const { width } = useWidgetContext();

    const mouseOverRef = useRef(new BarMouseOver());
    const { config } = useHistoricalPercentageChangeWidgetConfigSlice();

    const { chartHeight, chartTop } =
        useHistoricalPercentageChangeWidgetChartDimensions();

    const chartWidth = width - 22;

    const { hidePrice, hideVolume, hideAverageVolume } = config;

    const cssClasses = classNames(
        'HistoricalPercentageChangeWidgetChartWidget',
        hidePrice && 'hide-price',
        hideVolume && 'hide-volume',
        hideAverageVolume && 'hide-average-volume'
    );

    return (
        <div
            className={cssClasses}
            style={{
                height: chartHeight + 'px',
                width: width + 'px',
                top: chartTop + 'px',
            }}
        >
            <HistoricalPercentageChangeWidgetChartLegends
                defaultItem={data[data.length - 1]}
                mouseOver={mouseOverRef.current}
            />
            <div className={'HistoricalPercentageChangeWidgetChartContainer'}>
                <div className="vertical-label left-label">
                    <div className="inner rotate">Price</div>
                </div>
                <HistoricalPercentageChangeChart
                    barMouseOver={mouseOverRef.current}
                    hideAverageVolume={config.hideAverageVolume}
                    hidePrice={config.hidePrice}
                    hideVolume={config.hideVolume}
                    periodQty={config.periodQty}
                    data={data}
                    height={chartHeight}
                    width={chartWidth}
                    key={
                        // Nuclear option to ensure scales properly when height changes...
                        'HistoricalPercentageChangeChart-' + chartHeight
                    }
                />
                <div className="vertical-label right-label">
                    <div className="inner rotate">Volume</div>
                </div>
            </div>
        </div>
    );
}
